/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { i as isObject_1 } from '../_chunks/dep-88cd50bf.js';
import { RoundIcon, ChevronUpIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from 'tdesign-icons-react';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { Button } from '../button/index.js';
import { paginationMiniDefaultProps } from './defaultProps.js';
import noop from '../_util/noop.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-c3f1141e.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../button/Button.js';
import '../_chunks/dep-e43cf21c.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-92728dc5.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../_util/parseTNode.js';
import '../button/style/css.js';
import '../button/type.js';

var PaginationMini = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useGlobalIcon = useGlobalIcon({
      RoundIcon: RoundIcon,
      ChevronUpIcon: ChevronUpIcon,
      ChevronDownIcon: ChevronDownIcon,
      ChevronLeftIcon: ChevronLeftIcon,
      ChevronRightIcon: ChevronRightIcon
    }),
    RoundIcon$1 = _useGlobalIcon.RoundIcon,
    ChevronUpIcon$1 = _useGlobalIcon.ChevronUpIcon,
    ChevronDownIcon$1 = _useGlobalIcon.ChevronDownIcon,
    ChevronLeftIcon$1 = _useGlobalIcon.ChevronLeftIcon,
    ChevronRightIcon$1 = _useGlobalIcon.ChevronRightIcon;
  var variant = props.variant,
    tips = props.tips,
    showCurrent = props.showCurrent,
    disabled = props.disabled,
    layout = props.layout,
    size = props.size,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange,
    className = props.className,
    style = props.style;
  var titleConfig = useMemo(function () {
    if (isObject_1(tips)) return tips;
    if (tips === true) return {
      prev: "\u4E0A\u4E00\u9875",
      current: "\u5F53\u524D",
      next: "\u4E0B\u4E00\u9875"
    };
    return {};
  }, [tips]);
  var disabledConfig = useMemo(function () {
    if (isObject_1(disabled)) return disabled;
    if (disabled === true) return {
      prev: true,
      current: true,
      next: true
    };
    return {
      prev: false,
      current: false,
      next: false
    };
  }, [disabled]);
  return /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-pagination-mini"), className, _defineProperty({}, "".concat(classPrefix, "-pagination-mini--outline"), variant === "outline")),
    ref: ref,
    style: style
  }, /* @__PURE__ */React.createElement(Button, {
    title: titleConfig.prev,
    variant: variant,
    size: size,
    shape: "square",
    onClick: function onClick(e) {
      return onChange({
        e: e,
        trigger: "prev"
      });
    },
    icon: layout === "horizontal" ? /* @__PURE__ */React.createElement(ChevronLeftIcon$1, null) : /* @__PURE__ */React.createElement(ChevronUpIcon$1, null),
    className: "".concat(classPrefix, "-pagination-mini__prev"),
    disabled: disabledConfig.prev
  }), showCurrent && /* @__PURE__ */React.createElement(Button, {
    title: titleConfig.current,
    variant: variant,
    size: size,
    shape: "square",
    onClick: function onClick(e) {
      return onChange({
        e: e,
        trigger: "current"
      });
    },
    icon: /* @__PURE__ */React.createElement(RoundIcon$1, null),
    className: "".concat(classPrefix, "-pagination-mini__current"),
    disabled: disabledConfig.current
  }), /* @__PURE__ */React.createElement(Button, {
    title: titleConfig.next,
    variant: variant,
    size: size,
    shape: "square",
    onClick: function onClick(e) {
      return onChange({
        e: e,
        trigger: "next"
      });
    },
    icon: layout === "horizontal" ? /* @__PURE__ */React.createElement(ChevronRightIcon$1, null) : /* @__PURE__ */React.createElement(ChevronDownIcon$1, null),
    className: "".concat(classPrefix, "-pagination-mini__next"),
    disabled: disabledConfig.next
  }));
});
PaginationMini.displayName = "PaginationMini";
PaginationMini.defaultProps = paginationMiniDefaultProps;

export { PaginationMini as default };
//# sourceMappingURL=PaginationMini.js.map
